<template>
    <kiosk-layout>
        <div class="flex flex-col gap-12 lg:flex-row">
            <div class="shrink-0 lg:w-60">
                <kiosk-users-sidebar v-model="fetchParams"></kiosk-users-sidebar>
            </div>
            <div class="w-full">
                <kiosk-users-controls v-model="fetchParams" @reset="resetFilters"></kiosk-users-controls>
                <page-loading v-if="loading && !list.length"></page-loading>

                <vx-box
                    v-else-if="!list.length && !isEqual(defaultFilters(), fetchParams)"
                    color="info"
                    class="flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500"
                >
                    <div class="w-64 mx-auto text-center">
                        No results for current search, try adjusting your filters.
                    </div>
                    <vx-button type="button" color="secondary" @click="resetFilters">
                        Reset All
                        <font-awesome-icon widthAuto :icon="faCircleX" />
                    </vx-button>
                </vx-box>

                <div v-else-if="list.length">
                    <div class="text-xl font-extrabold">Results</div>
                    <kiosk-users-table>
                        <kiosk-user-row
                            v-for="(row, index) in response?.data?.data || []"
                            v-model="(response?.data?.data || [])[index]"
                            :key="row.id"
                        ></kiosk-user-row>
                    </kiosk-users-table>
                </div>
            </div>
        </div>
    </kiosk-layout>
</template>

<script setup>
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import { faCircleX } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton } from '@voxie/frontend-components';
import KioskUsersSidebar from './details/KioskUsersSidebar.vue';
import KioskUsersControls from './list/KioskUsersControls.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import KioskUsersTable from './list/KioskUsersTable.vue';
import KioskUserRow from './list/KioskUserRow.vue';
import { isEqual } from '~/utils/helpers';
import { computed, ref, watch } from 'vue';
import { adminUsersClient } from '~/services';
import { useVersionedRequest } from '~/composables/useVersionedRequest';

const defaultFilters = () => ({
    sort_dir: 'desc',
    sort_field: 'id',
    per_page: 100,
});

const fetchParams = ref(defaultFilters());
const { loading, response, fetchData } = useVersionedRequest();
const list = computed(() => response.value?.data?.data || []);

watch(
    fetchParams,
    () => {
        filterData();
    },
    {
        deep: true,
    }
);

const resetFilters = () => {
    fetchParams.value = defaultFilters();
    filterData();
};

const filterData = () => {
    fetchData(adminUsersClient.listUsers(fetchParams.value));
};

filterData();
</script>
